import AuthLayout from "../../components/authLayout"
import ForgetPassCard from "../../components/resetPassword"

const ResetPasswordPage = () => {
    return (
        <AuthLayout backgroundImageUrl="/assets/images/backgroundLogin.png">
            <ForgetPassCard />
        </AuthLayout>
    )
}

export default ResetPasswordPage